/*
 * @Author: Chao Yang
 * @Date: 2020-01-17 09:30:13
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-03-06 11:56:52
 */
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CancelService {
  unsubscribe = new Subject<void>();

  cancelPendingRequests(): void {
    this.unsubscribe.next();
  }

  onCancelPendingRequests(): Observable<void> {
    return this.unsubscribe.asObservable();
  }
}
